import { Component, OnInit, EventEmitter, Input, Output  } from '@angular/core';

const DEFAULTNAVLINKS = [
  {level: '0', label:'Begynder'},
  {level: '1', label:'Øvet'},
  {level: '2', label:'Expert'}
];


@Component({
  selector: 'app-levels',
  templateUrl: './levels.component.html',
  styleUrls: ['./levels.component.css']
})
export class LevelsComponent implements OnInit {
  @Input() inNavLinks; 
  @Output() onSetLevel = new EventEmitter<number>();
  mLevel: number;

  constructor() { }

  ngOnInit() {
    if (!this.inNavLinks)
    {
      this.inNavLinks = DEFAULTNAVLINKS;
    }
    this.mLevel = this.inNavLinks[0].level; 
  }

  setLevel(newLevel: number)
  {
    this.onSetLevel.emit(newLevel);
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/levels/levels.component.ts